import { ThemeUICSSObject } from 'theme-ui';
import getColorsAndStatesByPath from '../colors/util/getColorsAndStatesByPath';
/* IMPORT HERE */

const checkbox: ThemeUICSSObject = {
  borderRadius: 'default',
  ...getColorsAndStatesByPath('form.fields', {
    states: {
      active: false,
      focus: false,
      hover: false,
    },
  }),
  backgroundColor: 'unset',
  alignItems: 'center',

  '&.nativeCheckbox': {
    appearance: 'none',
    width: '25px',
    height: '25px',
    border: 'solid 1px #cccccc',
    marginRight: '8px',
    position: 'relative',
    cursor: 'pointer',

    '&:checked::before': {
      content: '"✓"',
      color: 'palette.text.primary',
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      fontSize: 'larger',
      fontWeight: 'bolder',
      borderRadius: '5px',
      cursor: 'pointer',
    },

    '&:indeterminate::before': {
      content: '"-"',
      color: 'palette.text.primary',
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: '-1px',
      left: 0,
      right: 0,
      bottom: 0,
      fontSize: 'xx-large',
      fontWeight: '600',
      borderRadius: '5px',
      cursor: 'pointer',
    },
  },
};

export default checkbox;
